import { default as originalGql } from 'graphql-tag';
import logWarningInDev from './helpers/logWarningInDev';
// Turns a fragment definition to an inline fragment
function inlineFragment(parsedDoc) {
    return parsedDoc.loc.source.body.replace(/fragment [_A-Za-z][_0-9A-Za-z]*/, '...');
}
export function gql(literals, ...placeholders) {
    const parsed = originalGql(literals, ...placeholders);
    if (parsed.definitions && parsed.definitions.length === 1) {
        if (parsed.definitions[0].kind === 'FragmentDefinition') {
            return inlineFragment(parsed);
        }
    }
    return parsed;
}
export default function deprecatedGql(literals, ...placeholders) {
    logWarningInDev(true, `Using 'gql' from '@jetshop/core' is deprecated and will not be supported in the next major version. Please extract your queries into .gql files instead.`);
    return gql(literals, ...placeholders);
}
//# sourceMappingURL=gql.js.map